import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-menu-add',
    templateUrl: './menu-add.component.html',
    styleUrls: ['./menu-add.component.scss']
})
export class MenuAddComponent implements OnInit {

    constructor(
		private router: Router,
		private http: HttpService,
		private el: ElementRef,
		private location: Location,
		public loading: LoadingService) { }
	@ViewChild('menuForm') menuForm: NgForm | undefined;
	private apiPath = 'navigation';
	parentList: any = [];
	stayPage: boolean = false;
	formGroup = new FormGroup({
	    parent_id: new FormControl(null),
	    name: new FormControl(null),
	    icon: new FormControl(null),
	    link: new FormControl(null),
	    action: new FormControl(null),
	    position: new FormControl(null),
	    status: new FormControl(1)
	});
	submitForm(form: any): void {
	    if (!form.valid) {
	        this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')[0].focus();
	        return;
	    }
	    form.disable();
	    let fdata = new FormData();
	    fdata.append('data', JSON.stringify(form.value));
	    this.http.Post(this.apiPath+'/create', fdata).then((r: any) => {
	        form.enable();
	        if (r.success) {
	            if (this.stayPage) {
	                const status = form.value?.status;
	                form?.reset();
	                this.menuForm?.resetForm();
	                form.get('status')?.setValue(status);
	                this.getParent();
	            } else {
	                this.router.navigate(['menu']);
	            }
	        }
	    });
	}
	getParent(): void {
	    this.http.Get(this.apiPath, { filter: { status: 1 } }).then((r: any) => {
	        if (r.success) {
	            this.parentList = r?.response?.result?.data || [];
	        }
	    });
	}
	back(): void {
	    this.location.back();
	}
	ngOnInit(): void {
	    this.getParent();
	}

}
